export const municipalitySetOptions = ({ giftRegistryNewAddress, userData }) => {
  if (!giftRegistryNewAddress) return [];
  const valid = Object.keys(giftRegistryNewAddress).length > 0 ? giftRegistryNewAddress.status : [];
  if (valid.status === 'failure') return { municipaltyOptions: [] };

  const { addrSearchResponse = {} } = Object.keys(giftRegistryNewAddress).length > 0 ? giftRegistryNewAddress : [];
  const { delegationMunicipality, delegationMunicipalityId } = userData || {};
  let resMunicipalty = addrSearchResponse.municipality || [];
  let municipaltyName = '';

  if (resMunicipalty.length > 0) {
    resMunicipalty = addrSearchResponse.municipality;
  } else if (delegationMunicipality && delegationMunicipalityId) {
    const municiArray = [];
    municiArray.push(`${[delegationMunicipalityId]}:${delegationMunicipality}`);
    resMunicipalty = municiArray;
  }

  const municipaltyOptions = [];

  if (resMunicipalty) {
    resMunicipalty.forEach((e) => {
      const index = e.indexOf(':');
      const id = e.substr(0, index);
      const text = e.substr(index + 1);
      const setMunicipaltyOptions = {};
      setMunicipaltyOptions.id = id;
      setMunicipaltyOptions.value = text;
      setMunicipaltyOptions.labelResourceId = text;
      municipaltyOptions.push(setMunicipaltyOptions);
    });
  }

  if (delegationMunicipality) {
    municipaltyName = delegationMunicipality;
  }

  if (municipaltyOptions.length > 0) {
    municipaltyName = municipaltyOptions[0].value;
  }

  return {
    municipaltyOptions,
    municipaltyName,
  };
};

export const colonySetOptions = ({ giftRegistryNewAddress, userData }) => {
  if (!giftRegistryNewAddress) return [];

  const valid = Object.keys(giftRegistryNewAddress).length > 0 ? giftRegistryNewAddress.status : [];
  if (valid.status === 'failure') return { colonyOptions: [] };

  const { addrSearchResponse = {} } = giftRegistryNewAddress || {};
  const { neighbourhood, neighbourhoodId = '' } = userData;
  let otherColonyValue = '';
  let resNeighbourhood = '';
  let colonyName = '';

  if (addrSearchResponse.neighbourhood) {
    resNeighbourhood = addrSearchResponse.neighbourhood;
  } else if (neighbourhood && neighbourhoodId !== '0000') {
    const neibhourArray = [];
    let object = {};
    if (neighbourhoodId === '-2') {
      object = neighbourhoodId + ':Otra colonia';
      neibhourArray.push(object);
      resNeighbourhood = neibhourArray;
    } else {
      object = neighbourhoodId + ':' + neighbourhood;
      neibhourArray.push(object);
      resNeighbourhood = neibhourArray;
    }
  }

  const colonyOptions = [];
  if (resNeighbourhood) {
    resNeighbourhood.forEach((e) => {
      const index = e.indexOf(':');
      const id = e.substr(0, index);
      const text = e.substr(index + 1);
      const _ColonyOptions = {};
      _ColonyOptions.id = id;
      _ColonyOptions.value = text;
      _ColonyOptions.labelResourceId = text;
      colonyOptions.push(_ColonyOptions);
    });

    if (colonyOptions[0].id !== '-2') { // append other colony with other colony option
      const _otherColonyOptions = {};
      _otherColonyOptions.id = '-2';
      _otherColonyOptions.value = 'Otra colonia';
      _otherColonyOptions.labelResourceId = 'Otra colonia';
      colonyOptions.unshift(_otherColonyOptions);
    }

    if (colonyOptions) {
      if (neighbourhoodId === '-2' && colonyOptions.length === 1) {
        otherColonyValue = neighbourhood || '';
        colonyName = colonyOptions[0].value;
      } else {
        otherColonyValue = '';
        colonyName = colonyOptions[1].value;
      }
    } else if (neighbourhood) {
      colonyName = userData.neighbourhood;
    }

    return { colonyOptions, colonyName, otherColonyValue };
  }

  const _otherColonyOptions = {}; // create option for other colony
  _otherColonyOptions.id = '-2';
  _otherColonyOptions.value = 'Otra colonia';
  _otherColonyOptions.labelResourceId = 'Otra colonia';
  colonyOptions.push(_otherColonyOptions);

  return { colonyOptions };
};

export const stateSetOptions = ({ stateList, giftRegistryNewAddress, userData }) => {
  if (!giftRegistryNewAddress) return [];
  const { addrSearchResponse = {}, status = {} } = giftRegistryNewAddress || {};
  const { state } = addrSearchResponse;
  const { state: stateUserData, stateId } = userData;

  const stateOptions = [];
  let stateLists = state || (status.status === 'failure' && []);
  let selectedStateValue = '';

  // * For first render when you want edit
  if (stateUserData && stateId && !(stateLists)) {
    const stateArray = [];
    stateArray.push(stateId + ':' + stateUserData);
    stateLists = stateArray;
  }

  // * For the search address
  if (Object.keys(stateLists).length > 0) {
    stateLists.forEach((e) => {
      const index = e.indexOf(':');
      const id = e.substr(0, index);
      const text = e.substr(index + 1);

      const _option = {};
      _option.id = id;
      _option.value = text === 'DISTRITO FEDERAL' ? 'DISTRITO FEDERAL' : text;
      _option.labelResourceId = text === 'DISTRITO FEDERAL' ? 'CDMX/Zona Metropolitana' : text;

      stateOptions.push(_option);
    });

    selectedStateValue = stateOptions.length > 0 ? stateOptions[0].value : '';
  }

  // * For selectors states when user add new address.
  if (!stateLists) {
    stateLists = (stateList?.stateListsInfo && stateList?.stateListsInfo.states) || [];
        //put this because it was giving an error to use for lop in if loop.
    for (let key of stateLists) {
      const _option = {};
      _option.id = Object.keys(key)[0];
      const defaultStateValue = key[Object.keys(key)[0]];
      const equalToDf = (defaultStateValue === 'DISTRITO FEDERAL');

      _option.value = equalToDf ? 'DISTRITO FEDERAL' : defaultStateValue;
      _option.labelResourceId = equalToDf ? 'CDMX/Zona Metropolitana' : defaultStateValue;

      stateOptions.push(_option);
    }
  }

  return stateOptions.length > 0 ? { stateOptions, selectedStateValue } : { stateOptions: []}
};
